import {Component, OnInit} from '@angular/core';
import { StorageService } from '../../services/storage.service';

declare const $: any;

@Component({
    selector: 'app-onboarding-modal',
    templateUrl: './onBoarding-modal.component.html',
    styleUrls: ['./onBoarding-modal.component.scss'],
    standalone: false
})
export class OnBoardingModalComponent implements OnInit {

  constructor(private storageService: StorageService) { }

  ngOnInit(): void {
  }

  initModal(): void {
    //if (!localStorage.getItem('onBoardingModal')) {
      this.initOnBoardingModal();
    //}
  }

  initOnBoardingModal(): void {
    const $onboardingModal = $('#onboarding-modal');
    const $onboardingSlider = $('#onboarding-slider');
    const $onboardingNextBtn = $('#onboarding-next');
    const $onboardingCount = $('#onboarding-count');
    const slideLength = $onboardingSlider.find('.modal-onboarding__slide').length;

    $onboardingModal.modal('show');

    // on modal load, init slider
    $onboardingModal.on('shown.bs.modal', () => {
      $onboardingSlider.not('.slick-initialized').slick({
        initialSlide: 0,
        arrows: false,
        dots: false,
        infinite: false,
        rows: 0,
      });
    });

    $onboardingModal.on('hidden.bs.modal', () => {
      $onboardingSlider.slick('slickGoTo', 0);
      $onboardingSlider.slick('unslick');
    });

    // on 'next' click
    $(document).on('click', '#onboarding-next', (e) => {
      e.preventDefault();
      const buttonAttribute = document.getElementById('onboarding-next').hasAttribute('data-dismiss');
      if (buttonAttribute) {
        this.acceptOrSkip();
      }

      $onboardingSlider.slick('slickNext');
    });

    // on change
    $onboardingSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      // update counter text
      $onboardingCount.text(nextSlide + 1);

      // update button text
      $onboardingNextBtn.removeAttr('data-dismiss');
      if (nextSlide === slideLength - 1) {
        $onboardingNextBtn.text('Got it').attr('data-dismiss', 'modal');
      } else if (nextSlide >= 1) {
        $onboardingNextBtn.text('Next');
      } else {
        $onboardingNextBtn.text('Let\'s Go');
      }
    });
  }

  acceptOrSkip(): void {
    this.storageService.set('onBoardingModal', 'true', 'user');
  }

}
